import React from 'react';
import { Typography } from 'antd';
import Progress from '../Progress';
import StyledButton from '../Common/Buttons/StyledButton';
import styles from './styles.module.less';
import Loader from '../Common/Loader';
import PropTypes from 'prop-types';
import { UserVerificationStatus } from '../../constants/userVerificationStatus';
import DecisionStatus from './components/DecisionStatus/DecisionStatus';
import { useNavigateToIdVerification } from '../../modules/client/idVerification/useNavigateToIdVerification';
import AlreadyHaveFMAccountModal from '../../containers/Brokers/IdVerification/components/AlreadyHaveFMAccountModal/AlreadyHaveFMAccountModal';

const { Title, Text } = Typography;

const IdVerificationStatus = ({ percent, isLoading, status, userId }) => {
  const {
    mappedIdentityData,
    handleVerifyYourIdentity,
    isConfirmModalOpen,
    handleCloseConfirmationModal,
    isLoading: isIdentityLoading,
  } = useNavigateToIdVerification(userId);

  const isDecisionDisplayed =
    status === UserVerificationStatus.POSTED ||
    status === UserVerificationStatus.REJECTED;

  const isInProgress =
    status === UserVerificationStatus.IN_PROGRESS ||
    status === UserVerificationStatus.NOT_VERIFIED;

  return (
    <div className={styles.wrapper}>
      {isInProgress && (
        <>
          <Title className={styles.title}>Verify your account</Title>
          {isLoading ? <Loader /> : <Progress percent={percent} />}

          <Text>{percent}%</Text>
          <StyledButton
            onClick={handleVerifyYourIdentity}
            type="outline"
            htmlType="button"
            text="Verify now"
            size="middle"
            loading={isIdentityLoading}
            className={styles.button}
          />

          <AlreadyHaveFMAccountModal
            rows={mappedIdentityData}
            isOpen={isConfirmModalOpen}
            onModalClose={handleCloseConfirmationModal}
          />
        </>
      )}
      {isDecisionDisplayed && <DecisionStatus status={status} />}
    </div>
  );
};

IdVerificationStatus.propTypes = {
  percent: Progress.propTypes.percent,
  isLoading: PropTypes.bool,
  status: PropTypes.string.isRequired,
  userId: PropTypes.number,
};

export default IdVerificationStatus;
